import { EventSeverity } from "@sitescene/types";

/**
 * Convert EventSeverity enum to a representative numeric value (1-10)
 */
export function eventSeverityToNumber(severity: EventSeverity): number {
	switch (severity) {
		case EventSeverity.Critical:
			return 9;
		case EventSeverity.High:
			return 7;
		case EventSeverity.Low:
			return 3;
		case EventSeverity.Moderate:
			return 5;
		default:
			return 5;
	}
}

/**
 * Get priority label and color for a numeric severity value.
 * Used for notifications (email, SMS) and exports.
 */
export function getEventPriorityLabel(severity: number): {
	color: string;
	label: string;
} {
	if (severity >= 9) return { color: "#C11574", label: "Critical" };
	if (severity >= 7) return { color: "#F72E6D", label: "High" };
	if (severity >= 5) return { color: "#EF6820", label: "Moderate" };
	return { color: "#079455", label: "Low" };
}

/**
 * Convert numeric severity value (1-10) to EventSeverity enum
 *
 * Mapping:
 * - 1-4 = Low
 * - 5-6 = Moderate
 * - 7-8 = High
 * - 9-10 = Critical
 */
export function numberToEventSeverity(severity: number): EventSeverity {
	if (severity >= 9) return EventSeverity.Critical;
	if (severity >= 7) return EventSeverity.High;
	if (severity >= 5) return EventSeverity.Moderate;
	return EventSeverity.Low;
}
